import Router from 'live/services/router'
import MenuService from 'live/services/menu'
import i18n from 'live/services/i18n'
import Companies from './Companies'
import { canManageCompany } from './permissions/index'

if(canManageCompany()){

Router.route('multi-company', Companies, 'multi-company')


MenuService.register({
    alias: 'live-multi-company',
    name: 'Company',
    component: Companies,
    order: 4,
    routeUrl: 'multi-company',
    url: '/#/multi-company/'
}, 'regular')

}

